import { useDecision } from '@optimizely/react-sdk'

const MENU_EXPERIENCE_RECIPE_DETAIL_OFX_FLAG = 'turnips_ofx_menu_experience_recipe_detail'

export const useIsMenuExperienceRecipeDetailEnabled = () => {
  const [featureFlagDecision] = useDecision(MENU_EXPERIENCE_RECIPE_DETAIL_OFX_FLAG)

  return featureFlagDecision.variationKey === 't1'
}
